export default __webpack_public_path__ + "static/media/wave.bdf65074.svg";